import type { AddressValue } from './AddressFields';

/** An address with nothing chosen or typed yet. */
export const EMPTY_ADDRESS: AddressValue = {
  countryCode: '',
  provinceCode: '',
  districtCode: '',
  wardCode: '',
  postalCode: '',
  street: '',
};
